import * as React from 'react';

interface IProps {
  children: React.ReactNode | React.ReactNode[];
  className?: string;
}

const Nav = ({ children, className }: IProps) => (
  <nav className={className} style={{ margin: 0 }}>
    {children}
  </nav>
);

export default Nav;
